/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface UserSwapServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param oldEmployerId 
     * @param newEmployerId 
     * @param file 
     */
    userSwapControllerImportUsers0(oldEmployerId: string, newEmployerId: string, file: Blob, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param oldEmployerId 
     * @param newEmployerId 
     * @param file 
     */
    userSwapControllerImportUsers1(oldEmployerId: string, newEmployerId: string, file: Blob, extraHttpRequestParams?: any): Observable<{}>;

}
